import Request from './request';

async function fetch() {
    return Request('get', "api/balance-specified/index");
}

async function save(data) {//保存余额指定数据
    return Request('post', "api/balance-specified/save", data);
}


export default {
    fetch,
    save,
};